import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-w-full" }
const _hoisted_2 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50 tw-p-2 sm:tw-p-3" }
const _hoisted_3 = { class: "tw--m-5" }
const _hoisted_4 = { class: "tw-mt-2 tw-border-t tw-border-slate-200/70 tw-pt-2" }
const _hoisted_5 = { class: "tw-min-w-0 tw-overflow-x-auto" }
const _hoisted_6 = { class: "tw-flex tw-flex-nowrap tw-items-center tw-gap-2 tw-whitespace-nowrap" }
const _hoisted_7 = { class: "tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap" }
const _hoisted_8 = {
  key: 0,
  "uk-switcher": "animation: uk-animation-fade; toggle: > *; connect: .trip-switcher",
  class: "tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap"
}
const _hoisted_9 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-emerald-500/15 tw-px-2 tw-py-0.5 tw-text-xs tw-text-emerald-800" }
const _hoisted_10 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700" }
const _hoisted_11 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-rose-500/15 tw-px-2 tw-py-0.5 tw-text-xs tw-text-rose-800" }
const _hoisted_12 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-rose-500/15 tw-px-2 tw-py-0.5 tw-text-xs tw-text-rose-800" }
const _hoisted_13 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700" }
const _hoisted_14 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700" }
const _hoisted_15 = {
  key: 1,
  "uk-switcher": "animation: uk-animation-fade; toggle: > *; connect: .trip-appt-switcher",
  class: "tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap"
}
const _hoisted_16 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700" }
const _hoisted_17 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700" }
const _hoisted_18 = { class: "tw-mt-3 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50" }
const _hoisted_19 = {
  key: 0,
  class: "uk-switcher uk-margin trip-switcher"
}
const _hoisted_20 = {
  key: 1,
  class: "uk-switcher uk-margin trip-appt-switcher"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_DispatchContainerModal = _resolveComponent("DispatchContainerModal")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_HourGlass = _resolveComponent("HourGlass")!
  const _component_EventSchedule = _resolveComponent("EventSchedule")!
  const _component_daily_dispatch_table = _resolveComponent("daily-dispatch-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SearchInput, {
        modelValue: _ctx.searchTerm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        placeholder: "Container Number, BL or Customer Name",
        class: "tw-w-full"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_Modal, {
        isOpen: _ctx.isDispatchContainerOpen,
        "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDispatchContainerOpen) = $event)),
        modalId: "daily-dispatch-container-modal",
        maxWidth: "7xl",
        hasCloseButton: false,
        onClose: _ctx.closeDispatchContainer
      }, {
        title: _withCtx(() => [...(_cache[15] || (_cache[15] = [
          _createTextVNode("Dispatch", -1)
        ]))]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DispatchContainerModal, {
              containerId: _ctx.selectedContainerId,
              onDispachContainerRefetch: _ctx.updateDispatchContainers,
              drivers: _ctx.drivers,
              onClose: _ctx.closeDispatchContainer
            }, null, 8, ["containerId", "onDispachContainerRefetch", "drivers", "onClose"])
          ])
        ]),
        _: 1
      }, 8, ["isOpen", "onClose"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.updateDispatchFilter('all')), ["prevent"]))
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.dispatchPeriod === 'all'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'])
                }, "All", 2)
              ]),
              _createElementVNode("li", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.updateDispatchFilter('today')), ["prevent"]))
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.dispatchPeriod === 'today'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'])
                }, "Today", 2)
              ]),
              _createElementVNode("li", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.updateDispatchFilter('tomorrow')), ["prevent"]))
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.dispatchPeriod === 'tomorrow'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'])
                }, "Tomorrow", 2)
              ]),
              _createElementVNode("li", {
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.updateDispatchFilter('dayAfter')), ["prevent"]))
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.dispatchPeriod === 'dayAfter'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'])
                }, "Day after", 2)
              ]),
              _createElementVNode("li", {
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.updateDispatchFilter('nextWeek')), ["prevent"]))
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.dispatchPeriod === 'nextWeek'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'])
                }, "Next week", 2)
              ])
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "tw-text-slate-300" }, "|", -1)),
            (!_ctx.isShowingAppointments)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.activeTripFilterIdx === 0
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeTripFilterIdx = 0))
                  }, [
                    _cache[16] || (_cache[16] = _createTextVNode(" In Progress ", -1)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.inProgressTrips.length), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.activeTripFilterIdx === 1
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeTripFilterIdx = 1))
                  }, [
                    _cache[17] || (_cache[17] = _createTextVNode(" Not started ", -1)),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.notStartedTrips.length), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.activeTripFilterIdx === 2
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.activeTripFilterIdx = 2))
                  }, [
                    _cache[18] || (_cache[18] = _createTextVNode(" Driver not assigned ", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.driverNotAssignedTrips.length), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.activeTripFilterIdx === 3
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.activeTripFilterIdx = 3))
                  }, [
                    _cache[19] || (_cache[19] = _createTextVNode(" Chassis not assigned ", -1)),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.chassisNotAssignedTrips.length), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.activeTripFilterIdx === 4
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.activeTripFilterIdx = 4))
                  }, [
                    _cache[20] || (_cache[20] = _createTextVNode(" Completed Moves ", -1)),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.completedTrips.length), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.activeTripFilterIdx === 5
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.activeTripFilterIdx = 5))
                  }, [
                    _cache[21] || (_cache[21] = _createTextVNode(" All Moves ", -1)),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.dailyTrips.length), 1)
                  ], 2)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.activeApptFilterIdx === 0
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.activeApptFilterIdx = 0))
                  }, [
                    _createVNode(_component_HourGlass),
                    _cache[22] || (_cache[22] = _createTextVNode(" Terminal Appointments ", -1)),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.terminalApptTrips.length), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur", _ctx.activeApptFilterIdx === 1
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.activeApptFilterIdx = 1))
                  }, [
                    _createVNode(_component_EventSchedule),
                    _cache[23] || (_cache[23] = _createTextVNode(" Delivery Appointments ", -1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.deliveryApptTrips.length), 1)
                  ], 2)
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (!_ctx.isShowingAppointments)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
              _createElementVNode("li", null, [
                _createVNode(_component_daily_dispatch_table, {
                  onUpdateContainers: _ctx.updateDispatchContainers,
                  drivers: _ctx.drivers,
                  trips: _ctx.inProgressTrips,
                  onSelectTrip: _ctx.selectTrip
                }, null, 8, ["onUpdateContainers", "drivers", "trips", "onSelectTrip"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_daily_dispatch_table, {
                  onUpdateContainers: _ctx.updateDispatchContainers,
                  drivers: _ctx.drivers,
                  trips: _ctx.notStartedTrips,
                  onSelectTrip: _ctx.selectTrip
                }, null, 8, ["onUpdateContainers", "drivers", "trips", "onSelectTrip"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_daily_dispatch_table, {
                  onUpdateContainers: _ctx.updateDispatchContainers,
                  trips: _ctx.driverNotAssignedTrips,
                  drivers: _ctx.drivers,
                  onSelectTrip: _ctx.selectTrip
                }, null, 8, ["onUpdateContainers", "trips", "drivers", "onSelectTrip"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_daily_dispatch_table, {
                  onUpdateContainers: _ctx.updateDispatchContainers,
                  drivers: _ctx.drivers,
                  trips: _ctx.chassisNotAssignedTrips,
                  onSelectTrip: _ctx.selectTrip
                }, null, 8, ["onUpdateContainers", "drivers", "trips", "onSelectTrip"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_daily_dispatch_table, {
                  onUpdateContainers: _ctx.updateDispatchContainers,
                  trips: _ctx.completedTrips,
                  onSelectTrip: _ctx.selectTrip,
                  drivers: _ctx.drivers
                }, null, 8, ["onUpdateContainers", "trips", "onSelectTrip", "drivers"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_daily_dispatch_table, {
                  onUpdateContainers: _ctx.updateDispatchContainers,
                  trips: _ctx.dailyTrips,
                  onSelectTrip: _ctx.selectTrip,
                  drivers: _ctx.drivers
                }, null, 8, ["onUpdateContainers", "trips", "onSelectTrip", "drivers"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_20, [
              _createElementVNode("li", null, [
                _createVNode(_component_daily_dispatch_table, {
                  onUpdateContainers: _ctx.updateDispatchContainers,
                  drivers: _ctx.drivers,
                  trips: _ctx.terminalApptTripsNotComplete,
                  tripsCompleted: _ctx.terminalApptTripsComplete,
                  appointmentsView: true,
                  terminalAppt: true,
                  onSelectTrip: _ctx.selectTrip
                }, null, 8, ["onUpdateContainers", "drivers", "trips", "tripsCompleted", "onSelectTrip"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_daily_dispatch_table, {
                  onUpdateContainers: _ctx.updateDispatchContainers,
                  drivers: _ctx.drivers,
                  appointmentsView: true,
                  deliveryAppt: true,
                  trips: _ctx.deliveryApptTrips,
                  onSelectTrip: _ctx.selectTrip
                }, null, 8, ["onUpdateContainers", "drivers", "trips", "onSelectTrip"])
              ])
            ]))
      ])
    ])
  ]))
}